export { LazyTemplatesGallery } from './LazyTemplatesGallery';
